import { postRequest } from "../services/apiHelpers";

export const postLogin = async (payload) => {
  try {
    const res = await postRequest({ url: "/auth/login", payload: payload });
    return res;
  } catch (e) {
    throw e;
  }
};

export const postLogout = async () => {
  try {
    const res = await postRequest({ url: "/auth/logout" });
    return res;
  } catch (e) {
    throw e;
  }
};

export const postVerifyOtp = async (payload) => {
  try {
    const res = await postRequest({
      url: "/auth/otp/verify",
      payload: payload,
    });
    return res;
  } catch (e) {
    throw e;
  }
};

export const postVerifyEmail = async (payload) => {
  try {
    const response = await postRequest({ url: "auth/verify", payload });
    return response;
  } catch (error) {
    throw new Error(error.message);
  }
};
